import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import draggable from "vuedraggable";
import { defineComponent, ref, toRefs, watchEffect } from "@vue/composition-api";
export default defineComponent({
  name: "List",
  components: {
    draggable
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const {
      list,
      readOnly
    } = toRefs(props);
    const modelItems = ref([]);
    const newItem = ref("");
    const nonce = ref(0);
    const itemRefs = ref([]);
    watchEffect(() => {
      var _context;
      modelItems.value = _mapInstanceProperty(_context = list.value).call(_context, (item, index) => ({
        text: item,
        editing: false,
        order: index
      }));
    });
    const remove = index => {
      var _context2;
      if (readOnly.value) return;
      _spliceInstanceProperty(_context2 = modelItems.value).call(_context2, index, 1);
      handleChange();
    };
    const edit = index => {
      if (readOnly.value) return;
      modelItems.value[index].editing = true;
      itemRefs.value[index].contentEditable = "true";
      setCursorToItem(index);
    };
    const stopEdit = index => {
      var _context3, _item$textContent;
      const item = itemRefs.value[index];
      const newText = _trimInstanceProperty(_context3 = (_item$textContent = item.textContent) != null ? _item$textContent : "").call(_context3);
      if (!newText) return;
      modelItems.value[index].editing = false;
      modelItems.value[index].text = newText;
      itemRefs.value[index].removeAttribute("contenteditable");
      handleChange();
    };
    const addItem = () => {
      var _context4;
      const newItemTrimmed = _trimInstanceProperty(_context4 = newItem.value).call(_context4);
      if (!newItemTrimmed) return;
      modelItems.value.push({
        text: newItem.value,
        editing: false,
        order: modelItems.value.length
      });
      newItem.value = "";
      handleChange();
    };
    const setCursorToItem = index => {
      const item = itemRefs.value[index];
      item.focus();
      if (window.getSelection && document.createRange) {
        const range = document.createRange();
        const sel = window.getSelection();
        range.selectNodeContents(item);
        range.collapse(false);
        if (sel === null) return;
        sel.removeAllRanges();
        sel.addRange(range);
      }
      if ("createTextRange" in document.body) {
        const textRange = document.body.createTextRange();
        textRange.moveToElementText(item);
        textRange.collapse(false);
        textRange.select();
      }
    };
    const handleChange = () => {
      var _context5;
      emit("input", _mapInstanceProperty(_context5 = modelItems.value).call(_context5, item => item.text));
      nonce.value++;
    };
    return {
      modelItems,
      newItem,
      nonce,
      itemRefs,
      remove,
      edit,
      stopEdit,
      addItem,
      handleChange
    };
  }
});